interface WebSiteSchemaProps {
  name?: string;
  url?: string;
  description?: string;
}

export function WebSiteSchema({
  name = 'ClimbingWeather.com',
  url = 'https://climbingweather.com',
  description = 'Get accurate weather forecasts for rock climbing areas across the United States.'
}: WebSiteSchemaProps) {
  // No SearchAction: the site has no search results URL, and Google retired the
  // sitelinks search box it was for
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name,
    url,
    description
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

interface PlaceSchemaProps {
  name: string;
  description?: string;
  latitude: number;
  longitude: number;
  elevation?: number;
  state: string;
  url: string;
}

export function PlaceSchema({
  name,
  description,
  latitude,
  longitude,
  elevation,
  state,
  url
}: PlaceSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Place',
    name,
    description: description || `Rock climbing area in ${state} with weather forecasts`,
    url,
    geo: {
      '@type': 'GeoCoordinates',
      latitude,
      longitude,
      ...(elevation && { elevation: `${elevation} ft` })
    },
    address: {
      '@type': 'PostalAddress',
      addressRegion: state,
      addressCountry: 'US'
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

interface BreadcrumbSchemaProps {
  items: Array<{ name: string; url: string }>;
}

export function BreadcrumbSchema({ items }: BreadcrumbSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url
    }))
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
